const styles = theme => ({
    section: {
        marginBottom: theme.spacing(1)
    },
    emptyMessage: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    fullScreenHeader: {
        color: theme.palette.text.tertiary,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    competence: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    competenceGroupHeader: {
        fontWeight: 600,
        marginTop: 10
    }
});

export default styles;